import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <section className="text-white bg-black space-y-4 p-4 text-left  sm:px-4 lg:px-8 2xl:px-10 4xl:px-48">
      <Link to="/">
        <img
          className="h-10 w-auto object-contain mx-auto xl:mx-0"
          src="/images/logoBangla.png"
          alt="Workflow"
        />
      </Link>
      <p className="text-lg xl:text-3xl text-center font-bold uppercase">
        Terms and Conditions for Satarko
      </p>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">Introduction</p>
        <article className="font-light text-sm ">
          Welcome to Satarko. We are proud to introduce Satarko, an advanced
          intruder alarm system designed and manufactured in Bangladesh. By
          downloading, installing, or using Satarko, you agree to comply with
          and be bound by these Terms and Conditions. If you do not agree with
          these Terms and Conditions, please do not access in Satarko.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          License and Use
        </p>
        <article className="font-light text-sm ">
          Satarko grants you a limited, non-exclusive, non-transferable, and
          revocable license to use the application for personal and
          non-commercial purposes. This license does not permit you to modify,
          reverse engineer, decompile, or disassemble Satarko, or create
          derivative works based on the application. Unauthorized use of Satarko
          may result in the termination of this license and may be subject to
          legal action.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          User Responsibilities
        </p>
        <article className="font-light text-sm ">
          As a user, you are responsible for ensuring that your use of Satarko
          complies with all applicable laws and regulations. You agree not to
          use Satarko for any unlawful or prohibited activities, including but
          not limited to hacking, unauthorized access, or disruption of the
          application or related systems. You are responsible for maintaining
          the confidentiality of your account information and for any activities
          that occur under your account.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Privacy and Data Collection
        </p>
        <article className="font-light text-sm ">
          Satarko is committed to protecting your privacy. By using Satarko, you
          consent to the collection, use, and sharing of your information as
          described in our Privacy Policy. We may collect and use personal data
          to improve Satarko and provide you with a better user experience. We
          do not share your personal data with third parties without your
          consent, except as required by law.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Updates and Changes
        </p>
        <article className="font-light text-sm ">
          Satarko reserves the right to modify, update, or discontinue the
          application or any part thereof at any time without notice. We may
          also update these Terms and Conditions from time to time. Your
          continued use of Satarko after any such changes constitutes your
          acceptance of the new Terms and Conditions. It is your responsibility
          to review these Terms and Conditions periodically for changes.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Limitation of Liability
        </p>
        <article className="font-light text-sm ">
          To the maximum extent permitted by law, Satarko shall not be liable
          for any direct, indirect, incidental, special, or consequential
          damages arising out of or in connection with your use of
          theapplication. This includes, but is not limited to, any loss of
          data, revenue, or profits, or any other economic loss, even if we have
          been advised of the possibility of such damages.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Indemnification
        </p>
        <article className="font-light text-sm ">
          You agree to indemnify, defend, and hold harmless Satarko, its
          affiliates, and their respective officers, directors, employees, and
          agents from and against any and all claims, liabilities, damages,
          losses, and expenses, including reasonable attorneys' fees, arising
          out of or in any way connected with your use of the application or
          violation of these Terms and Conditions.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">Termination</p>
        <article className="font-light text-sm ">
          Satarko reserves the right to terminate or suspend your access to the
          application at any time, with or without cause or notice. Upon
          termination, your right to use Satarko will immediately cease. All
          provisions of these Terms and Conditions which by their nature should
          survive termination shall survive termination, including, without
          limitation, ownership provisions, warranty disclaimers, indemnity, and
          limitations of liability.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Governing Law and Dispute Resolution
        </p>
        <article className="font-light text-sm ">
          These Terms and Conditions shall be governed by and construed in
          accordance with the laws of Bangladesh, without regard to its conflict
          of law principles. Any disputes arising out of or in connection with
          these Terms and Conditions or the use of the application shall be
          resolved through negotiation, mediation, or binding arbitration in
          Bangladesh.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Disclaimer of Warranties
        </p>
        <article className="font-light text-sm ">
          Satarko is provided "as is" and "as available" without warranties of
          any kind, either express or implied, including, but not limited to,
          implied warranties of merchantability, fitness for a particular
          purpose, and non-infringement. Satarko does not warrant that the
          application will be uninterrupted, error-free, or free of viruses or
          other harmful components.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Third-Party Services
        </p>
        <article className="font-light text-sm ">
          Satarko may include links to third-party websites or services that are
          not owned or controlled by Satarko. We have no control over, and
          assume no responsibility for, the content, privacy policies, or
          practices of any third-party websites or services. You acknowledge and
          agree that Satarko shall not be responsible or liable, directly or
          indirectly, for any damage or loss caused or alleged to be caused by
          or in connection with the use of or reliance on any such content,
          goods, or services available on or through any such websites or
          services.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Intellectual Property
        </p>
        <article className="font-light text-sm ">
          All content, features, and functionality of Satarko, including but not
          limited to text, graphics, logos, icons, images, audio clips, video
          clips, data compilations, and software, are the exclusive property of
          Satarko and are protected by copyright, trademark, patent, trade
          secret, and other intellectual property or proprietary rights laws.
          You agree not to reproduce, duplicate, copy, sell, resell, or exploit
          any portion of the application without the express written permission
          of Satarko.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Feedback and Suggestions
        </p>
        <article className="font-light text-sm ">
          Any feedback, comments, or suggestions you may provide regarding
          Satarko is entirely voluntary and we will be free to use such
          feedback, comments, or suggestions as we see fit and without any
          obligation to you.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">Severability</p>
        <article className="font-light text-sm ">
          If any provision of these Terms and Conditions is found to be invalid
          or unenforceable by a court of competent jurisdiction, such provision
          shall be severed from the remainder of these Terms and Conditions,
          which will otherwise remain in full force and effect.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Entire Agreement
        </p>
        <article className="font-light text-sm ">
          These Terms and Conditions, together with our Privacy Policy,
          constitute the entire agreement between you and Satarko regarding the
          use of the application and supersede all prior agreements and
          understandings, whether written or oral, relating to the application.
        </article>
      </div>
      <div className="space-y-2">
        <p className="text-base xl:text-xl font-bold uppercase">
          Contact Information
        </p>
        <article className="font-light text-sm ">
          If you have any questions or concerns about these Terms and Conditions
          or the application, please contact us at 3rd-4th floor, 165 Mirpur Rd,
          Dhaka 1205. By using the Satarko application, you acknowledge that you
          have read, understood, and agree to be bound by these Terms and
          Conditions. Thank you for choosing Satarko to secure your premises.
        </article>
      </div>
    </section>
  );
};

export default TermsAndConditions;
